<template>
  <!-- 2カラムページの場合は'is-2column'クラスを付与 -->
  <!-- ヘッダーを隠すの場合は'is-hidden-header'クラスを付与 -->
  <div id="body"
    :class="{'is-hidden-header' : targetScrollFlg}"
    @scroll="handleScroll"
  >
  <BackgroundImage />

    <!-- menu:start -->
    <PCMenu
      class="visible"
      v-if="visibleMenu"
      @closeMenu="visibleMenu = false"
    />
    <!-- menu:end -->

    <div id="wrapper">
      <PCContractHeader />

      <!-- menu-bar:start -->
      <!-- open -->
      <div class="menu-bar" role="button" 
        :class="{'is-open' : !targetScrollFlg}"
        @click="visibleMenu = !visibleMenu"
      >
        <IconMenu class="icn" 
          v-if="!targetScrollFlg"
        />
        <FontawesomeIcon :icon="['far','chevron-up']" size="lg" class="icn"
          v-if="targetScrollFlg"
        />
      </div>
      <!-- close -->
      <!-- menu-bar:end -->

      <!-- content:start -->
      <div id="content"
        style="height:calc(100vh - 16px);"
        >
        <div class="contract" id="scroll-target"
          @scroll="handleScroll"
          >
          <div class="contract-head">
            <h1 class="hdg03">申し込み履歴</h1>
          </div>
          <div v-for="(agreement, index) in historyOfPurchase" :key="'agreement'+index" class="contract-container">
            <div class="contract-content">
              <div class="purchase-info">
                <div class="purchase-info-content">
                  <dl class="purchase-info-list">
                    <dt>申込内容</dt>
                    <dd>{{format.status(agreement)}}</dd>
                    <dt>申込日</dt>
                    <dd>{{format.date(agreement.created)}}</dd>
                    <template v-if="decision.isPayment(agreement)">
                      <dt>合計金額</dt>
                      <dd>{{format.price(agreement.price)}}</dd>
                      <dt>支払い方法</dt>
                      <dd>{{agreement.payment}}</dd>
                    </template>
                  </dl>
                  <p v-if="decision.adminEdit(agreement)" class="txt">新日本法規による登録</p>
                  <p v-if="decision.isCancel(agreement) && decision.cancelCancelProduct(agreement).length > 0">
                    <template v-for="(product, cancelIndex) in decision.cancelCancelProduct(agreement)">
                      {{product.name}}の解約予約は取り消しされました。
                      <br v-if="cancelIndex !== decision.cancelCancelProduct(agreement).length - 1" :key="'cancel_' + cancelIndex">
                    </template>
                  </p>
                </div>
                <p class="purchase-info-id txt-sup">{{format.apNo(agreement.application_no_date, agreement.application_no)}}</p>
              </div>
              <div v-for="(_pack, packageIndex) in agreement.package_lists" :key="'package' + packageIndex" class="purchase-detail">
                <div class="purchase-detail-heading">
                  <h2 class="hdg03">{{_pack.package_name}}</h2>
                  <p v-if="decision.isPayment(agreement) && _pack.price > 0" class="purchase-detail-heading-sub">
                    <span>ご請求金額</span>合計
                    <strong>{{format.allPrice(_pack.price)}}</strong>
                    円（税込）
                  </p>
                  <p v-else-if="decision.isPayment(agreement)" class="purchase-detail-heading-sub">
                    <span>ご請求金額</span>合計
                    <strong>{{format.allPrice(_pack.price)}}</strong>
                  </p>
                  <p v-if="decision.isContinue(agreement)" class="purchase-detail-heading-text">自動継続されたライセンスは、{{formatDateKanji(_pack.period_end)}} まで。</p>
                  <p v-else-if="decision.isCancel(agreement)" class="purchase-detail-heading-text">お申し込みいただいたライセンスは、{{endDate(_pack.period_end)}} から無効。</p>
                  <p v-else-if="decision.getPeriodEnd(agreement)" class="purchase-detail-heading-text">お申し込みいただいたライセンスは、{{formatDateKanji(decision.getPeriodEnd(agreement))}} まで。</p>
                </div>
                <PurchaseTable v-if="decision.isPayment(agreement)" :pack="_pack" />
                <TrialTable v-else-if="decision.isTrial(agreement)" :pack="_pack" />
                <CancelTableForHistory v-else-if="decision.isCancel(agreement)" :pack="_pack" />
                <EstimateTable v-else-if="decision.isFirst(agreement)" :pack="_pack" />
              </div>
            </div>
          </div>
        </div>
      </div>
      <!-- content:end -->
      <span id="btnTop" @click="scrollAreaTop('#scroll-target')">TOP</span>
    </div>
  </div>
</template>

<script>
import { defineComponent } from '@vue/composition-api'
import { ContractHistoryOfPurchase } from '@/logic/contract/ContractHistoryOfPurchase'

import PCContractHeader from '@/components/pc/partial/contract/ContractHeader.vue'
import PCMenu from '@/components/pc/popup/PCMenu.vue'
import PurchaseTable from '@/components/pc/partial/contract/PurchaseTable.vue'
import TrialTable from '@/components/pc/partial/contract/TrialTable.vue'
import CancelTableForHistory from '@/components/pc/partial/contract/CancelTableForHistory.vue'
import EstimateTable from '@/components/pc/partial/contract/EstimateTable.vue'

export default defineComponent({
  components: {
    PCContractHeader,
    PCMenu,
    PurchaseTable,
    TrialTable,
    CancelTableForHistory,
    EstimateTable
  },
  setup (props, context) {
    return { ...ContractHistoryOfPurchase(props, context) }
  }
})
</script>

<style lang="scss" scoped>
#header {
  @media screen and (max-width: 1250px) {
    .header-search-tab {
      position: relative;
      &-02 {
        position: absolute;
        top: 52px;
        background-color: #fff;
        border-radius: 4px;
        box-shadow: 0px 3px 6px rgba(0,0,0,.16);
        .header-search-tab-item {
          height: 48px;
          padding: 0 10px;
          a {
            color: $color-link;
            padding: 2px 10px;
            font-size: 1.4rem;
          }
        }
      }
    }
  }
}
#content {
  background-color: #fff;
  border-radius: 8px 8px 0 0;
  margin-bottom: 60px;
  overflow-y: auto;
}
.contract {
  width: 100%;
  overflow: auto;
  &-container {
    border-top: 1px solid $color-line;
    padding: 32px 0 48px;
  }
  &-head {
    padding: 30px 40px 25px;
    [class^="hdg"] {
      margin-bottom: 0;
    }
  }
  &-content {
    max-width: 1105px;
    padding: 0 40px;
    margin: 0 auto;
    .txt {
      line-height: 1.625;
    }
    .hdg03 {
      margin: 0;
    }
  }
  .purchase{
    &-info{
      display: table;
      width: 100%;
      table-layout: fixed;
      &-content{
        display: table-cell;
        vertical-align: top;
        width: 60%;
      }
      &-list{
        dt{
          display: inline-block;
          width: 100px;
          font-weight: bold;
          margin-bottom: 8px;
          color: $color-hdg;
        }
        dd{
          display: inline-block;
          width: calc(100% - 100px);
          margin-bottom: 8px;
          color: $color-content;
        }
      }
      &-id{
        display: table-cell;
        vertical-align: top;
        width: 40%;
        text-align: right;
        line-height: 1;
      }
    }
    &-detail{
      margin-top: 32px;
      border-radius: 4px;
      border: 1px solid $color-line;
      & + .purchase-detail{
        margin-top: 48px;
      }
      &-heading{
        background: $color-bg-paper;
        padding: 32px 40px 36px;
        &-sub{
          font-size: 16px;
          line-height: 1.625;
          margin-top: 8px;
          color: $color-content;
          span{
            font-weight: bold;
            margin-right: 25px;
            color: $color-hdg;
          }
          strong{
            font-size: 24px;
            font-weight: bold;
            margin: 0 10px;
            color: $color-hdg;
          }
        }
        &-text{
          font-size: 16px;
          line-height: 1.625;
          margin-top: 5px;
          color: $color-content;
        }
      }
      &-content{
        padding: 40px;
        .hdg04{
          margin: 44px 0 8px;
        }
      }
      &-table{
        .tbl{
          thead{
            th{
              background: $color-bg-paper;
              border-bottom: 1px solid $color-line;
              padding: 22px 20px 15px;
              font-weight: normal;
              color: $color-content;
            }
          }
          tbody{
            th,td{
              padding: 26px 20px 22px;
            }
            th{
              font-weight: bold;
              color: $color-hdg;
              text-align: left;
              border-top: 1px solid $color-line;
            }
            td{
              color: $color-content;
            }
          }
        }
      }
    }
  }
}
</style>
